import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { filter, map } from 'rxjs/operators';


export interface AppEvent {
  type: string;
  data?: any;
}

@Injectable({
  providedIn: 'root'
})
export class EventService {

  private eventSubject = new Subject<AppEvent>();

  events$ = this.eventSubject.asObservable();

  // Método genérico para emitir eventos
  emit(eventType: string, data?: any) {
    this.eventSubject.next({ type: eventType, data });
  }

  // Método para escuchar eventos específicos
  on(eventType: string) {
    return this.events$.pipe(
      filter(event => event.type === eventType),
      map(event => event.data)
    );
  }
}
